// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'
import Axios from 'axios'
import moment from 'moment-timezone'
import store from './store'
import numeral from 'numeral'
import VueLazyload from 'vue-lazyload'

Vue.prototype.$http = Axios

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueCookies)
Vue.use(VueLazyload)

Vue.config.productionTip = false
Axios.defaults.withCredentials = true

Vue.filter('commas', function (value) {
  if (typeof value === 'string' && value.slice(0, 1) === '$') {
    return '$' + numeral(value).format('0,0')
  }
  return numeral(value).format('0,0')
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM Do YYYY, h:mm:ss a')
  }
})

Vue.filter('formatWeekDateTime', function (value) {
  if (value) {
    return moment(String(value)).tz('America/Chicago').format('dddd, MMMM Do YYYY')
  }
})

Vue.filter('upper', function (value) {
  if (value) {
    return value.toUpperCase()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js